(function() {
  var STORAGE_KEY = 'tat_wishlist';

  function loadWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function inWishlist(list, variantId) {
    return list.some(function(item) {
      return String(item.variantId) === String(variantId);
    });
  }

  function updateButtonState(btn, isActive) {
    if (!btn) return;
    var labelEl = btn.querySelector('.tat-wishlist-label');
    var iconEl  = btn.querySelector('.tat-wishlist-icon');
    if (isActive) {
      btn.classList.add('tat-wishlist-active');
      if (labelEl) labelEl.textContent = 'Saved to wishlist';
      if (iconEl) iconEl.textContent = '♥';
    } else {
      btn.classList.remove('tat-wishlist-active');
      if (labelEl) labelEl.textContent = 'Add to wishlist';
      if (iconEl) iconEl.textContent = '♡';
    }
  }

  // ---------- Toggle-Buttons auf Produktseiten / Grids ----------

  function bindWishlistToggles() {
    var current = loadWishlist();

    document.querySelectorAll('.tat-wishlist-toggle').forEach(function(btn) {
      if (btn.__tatBound) return;
      btn.__tatBound = true;

      var variantId = btn.getAttribute('data-variant-id');
      var handle    = btn.getAttribute('data-product-handle') || '';
      var title     = btn.getAttribute('data-product-title') || '';
      var url       = btn.getAttribute('data-product-url') || (handle ? '/products/' + handle : '#');
      var image     = btn.getAttribute('data-product-image') || '';

      // initial state
      updateButtonState(btn, inWishlist(current, variantId));

      btn.addEventListener('click', function() {
        var list = loadWishlist();

        if (inWishlist(list, variantId)) {
          // remove
          list = list.filter(function(item) {
            return String(item.variantId) !== String(variantId);
          });
          saveWishlist(list);
          updateButtonState(btn, false);
        } else {
          // add
          list.push({
            variantId: variantId,
            handle: handle,
            title: title,
            url: url,
            image: image
          });
          saveWishlist(list);
          updateButtonState(btn, true);
        }
      });
    });
  }

  // ---------- Wishlist-Seite rendern ----------

  function renderWishlistPage() {
    var container = document.getElementById('tatWishlistContainer');
    if (!container) return;

    var list = loadWishlist();

    if (!list.length) {
      container.innerHTML =
        '<p class="tat-wishlist-empty">Your wishlist is empty. Browse the shop and hit “Add to wishlist” on your favourite cards.</p>';
      return;
    }

    var html = '<div class="tat-wishlist-grid">';
    list.forEach(function(item) {
      var handle = item.handle || '';
      var url = item.url || (handle ? '/products/' + handle : '#');
      var title = item.title || (handle ? handle.replace(/-/g, ' ') : 'View product');
      var image = item.image || '';

      html +=
        '<div class="tat-wishlist-item" data-variant-id="'+ (item.variantId || '') +'">' +
          '<a class="tat-wishlist-thumb" href="'+ url +'">' +
            (image
              ? '<img class="tat-wishlist-image" src="'+ image +'" alt="'+ title +'">'
              : '<div class="tat-wishlist-placeholder">☆</div>'
            ) +
          '</a>' +
          '<a class="tat-wishlist-title" href="'+ url +'">'+ title +'</a>' +
          '<div class="tat-wishlist-actions">' +
            '<button class="tat-wishlist-add btn-black" data-variant-id="'+ (item.variantId || '') +'">Add to cart</button>' +
            '<button class="tat-wishlist-remove" data-variant-id="'+ (item.variantId || '') +'">Remove</button>' +
          '</div>' +
        '</div>';
    });
    html += '</div>';

    container.innerHTML = html;

    // Remove buttons
    container.querySelectorAll('.tat-wishlist-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var vid = String(btn.getAttribute('data-variant-id'));
        var list = loadWishlist().filter(function(i) {
          return String(i.variantId) !== vid;
        });
        saveWishlist(list);
        renderWishlistPage();
        bindWishlistToggles();
      });
    });

    // Add-to-cart buttons
    container.querySelectorAll('.tat-wishlist-add').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) {
          alert('Missing variant. Please open the product page.');
          return;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function() {
          btn.textContent = 'Added ✔';
        })
        .catch(function() {
          alert('Could not add to cart. Please try again.');
        });
      });
    });
  }

  function init() {
    bindWishlistToggles();
    renderWishlistPage();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function() {
    bindWishlistToggles();
    renderWishlistPage();
  });
})();
